import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

export const trackCartPreviewEmpty = () =>
  pushGTMEvent({
    event: 'Track',
    category: 'notification',
    action: 'notice_shown_in_minicart',
    label: 'empty_cart',
    value: 0,
  });

export const trackCartPreviewEmptyEditorSuggestion = () =>
  pushGTMEvent({
    event: 'Track',
    category: 'minicart',
    action: 'editor_suggestion',
    label: '',
    value: 0,
  });

export const trackCartPreviewEmptyEditorSuggestionLinkClick = (label: string) =>
  pushGTMEvent({
    event: 'Track',
    category: 'minicart',
    action: 'continued_to_editor_suggestion',
    label,
    value: 0,
  });
